import { createSelector } from 'reselect';
import { statsLeadersSelector } from './simple-selectors';

export const statsLeadersFiltersSelector = createSelector(
    statsLeadersSelector,
    statsLeaders => statsLeaders.filters
);